import React from 'react';
import { SETTINGS, STATES } from 'modules/emergencies/constants';
import { ReactComponent as AssignationStatusUnassignedIcon } from 'assets/icons/assignation-status-unassigned.svg';
import AvatarLetters from 'modules/emergencies/components/ui/avatar/avatarLetters';
import AvatarWrapper from 'modules/emergencies/components/ui/avatar/avatarWrapper';
import AvatarsContainer from 'modules/emergencies/components/ui/avatar/avatarsContainer';
import BodyColumn from 'modules/emergencies/components/ui/columns/bodyColumn';
import { AgentAssignedTooltip, AgentCreationTooltip } from '../tooltips';
import { Tooltip } from '@ontruck/orc';
import { generateColor, getUserInitials } from '../utils/user';
import useAssignAgentModal from 'modules/emergencies/components/modals/useAssignAgentModal';
import usePriceNegotiationPermissions from 'modules/emergencies/permissions/usePriceNegotiationPermissions';
import PRICE_NEGOTIATION_PERMISSIONS_NAMES from 'modules/emergencies/permissions/priceNegotiationPermissionsNames';
import styled from 'styled-components';

const Separator = styled.div`
  height: 100%;
  width: 2px;
  border: 1px solid var(--white);
`;

const StyledBodyColumn = styled(BodyColumn)`
  padding-left: 0;
  padding-top: 0;
  padding-bottom: 0;
  background-color: var(--white);
  border-left: 2px solid var(--white);
  border-right: 2px solid var(--white);
  overflow: hidden;
`;

const StyledAvatarContainer = styled(AvatarsContainer)`
  height: 100%;
  & > span {
    height: 100%;
  }
`;

const StyledAvatarWrapper = styled(AvatarWrapper)`
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: none;
  border-right: none;
  border-bottom-color: ${({ withBottomBorder }) => (withBottomBorder ? '#2396dc' : 'transparent')};
  height: 100%;
  background-color: var(--grey100);
  flex-grow: 1;
`;

export const OwnerAgentColumn = ({ ticket, reset }) => {
  const canAssignAgent = usePriceNegotiationPermissions(
    PRICE_NEGOTIATION_PERMISSIONS_NAMES.ACTION_ASSIGN_TO_AGENT
  );
  const hasAgent = !!ticket?.assigned_to?.id;
  const disabledStates = [STATES.CANCELLED, STATES.DONE, STATES.OUT_OF_SCOPE, STATES.ACCEPTED];
  const assignDisabled = !canAssignAgent || disabledStates.includes(ticket.synthetic_state);
  const { openModalAssignUser } = useAssignAgentModal(ticket, reset);
  const workingAreas = ticket?.working_areas || [];
  const canBeAssignedToRegion = workingAreas.length >= 2;

  return (
    <StyledBodyColumn width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.OWNER}>
      <StyledAvatarContainer>
        {/* created by */}
        <Tooltip component={<AgentCreationTooltip ticket={ticket} />} position="left" skin="dark">
          <StyledAvatarWrapper withBorderLeft={true}>
            <AvatarLetters>{getUserInitials(ticket?.created_by)}</AvatarLetters>
          </StyledAvatarWrapper>
        </Tooltip>
        {/* Assign agent */}
        <Separator />
        <Tooltip
          component={<AgentAssignedTooltip ticket={ticket} disabled={assignDisabled} />}
          position="left"
          skin="dark"
        >
          <StyledAvatarWrapper
            withBorderLeft={true}
            onClick={() => !assignDisabled && openModalAssignUser()}
            active={!assignDisabled}
            withBottomBorder={canBeAssignedToRegion}
          >
            {hasAgent ? (
              <AvatarLetters background={generateColor(ticket?.assigned_to?.username)}>
                {getUserInitials(ticket?.assigned_to)}
              </AvatarLetters>
            ) : (
              <AssignationStatusUnassignedIcon />
            )}
          </StyledAvatarWrapper>
        </Tooltip>
      </StyledAvatarContainer>
    </StyledBodyColumn>
  );
};
